import React from "react";
import { Box, Typography, Grid, Card, CardContent, Grow } from "@mui/material";
import { Person } from "@mui/icons-material";
import styled from "styled-components";
import profileImage from "../../resources/cory-headshot.jpg";

const ProfileCard = styled(Card)`
  height: 100%;
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  border-radius: 20px;
  overflow: hidden;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
  }
`;

const ContentCard = styled(Card)`
  height: 100%;
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.95);
`;

function ProfileSection() {
  return (
    <Grid container spacing={4}>
      {/* Profile Image */}
      <Grid item xs={12} md={4}>
        <Grow in timeout={1000}>
          <ProfileCard>
            <Box
              component="img"
              src={profileImage}
              alt="Cory Smith - Application Developer"
              sx={{
                width: "100%",
                height: "400px",
                objectFit: "cover",
              }}
            />
          </ProfileCard>
        </Grow>
      </Grid>

      {/* About Content */}
      <Grid item xs={12} md={8}>
        <Grow in timeout={1200}>
          <ContentCard>
            <CardContent sx={{ p: 4 }}>
              <Typography
                variant="h4"
                component="h2"
                gutterBottom
                sx={{
                  fontWeight: 600,
                  color: "#333",
                  mb: 3,
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Person sx={{ color: "#0066CC" }} />
                Background
              </Typography>

              <Typography
                variant="body1"
                paragraph
                sx={{ fontSize: "1.1rem", lineHeight: 1.8, color: "#555" }}
              >
                Hello, I'm Cory Smith, an enthusiastic and dedicated Application
                Developer based in Arlington, Texas. With a passion for
                technology and a drive to create innovative solutions, I am
                committed to delivering high-quality applications that enhance
                user experiences and improve customer satisfaction.
              </Typography>

              <Typography
                variant="body1"
                paragraph
                sx={{ fontSize: "1.1rem", lineHeight: 1.8, color: "#555" }}
              >
                With a full-stack development background, my expertise spans a
                wide range of technologies, including React.js for front-end
                development and C#/.NET for back-end development. I'm also
                proficient in Java, JavaScript, Python, and more.
              </Typography>
            </CardContent>
          </ContentCard>
        </Grow>
      </Grid>
    </Grid>
  );
}

export default ProfileSection;
